import { Grid, Typography } from "@material-ui/core";
import ButtonLoginWithItsme from "components/buttons/primary-buttons/ButtonLoginWithItsme";
import React from "react";
import { Trans } from "react-i18next";
import "./login-itsme-only.scss";

type LoginItsmeOnlyProps = {
    spFull: string;
    acs: string;
};

export default class LoginItsmeOnly extends React.Component<LoginItsmeOnlyProps, any> {
    render(): React.ReactElement {
        const { spFull, acs } = this.props;
        return (
            <Grid container>
                <Grid item xs={12} className="btn-login-itsme">
                    <ButtonLoginWithItsme spFull={spFull} acs={acs} />
                </Grid>
                <Grid item xs={12}>
                    <Typography className="info-text info-text-text only-itsme">
                        <Trans i18nKey="LoginPage.LoginBySp.OnlyItsme.LogInSecurely">
                            It is now possible
                            <strong>to log in securely</strong>, without installing the Portima Connect application, via
                            itsme! This gives you access to the <strong>full application</strong>.
                        </Trans>
                    </Typography>
                </Grid>
            </Grid>
        );
    }
}
